import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import LogoImg from "./../assets/AyurvedaAssets/images/logo.svg";

export default function UserPanelHeader({ OpenMenu, toggleMenuSidebar }) {
  const [drop, showDrop] = useState(null);

  const toggleDropDown = (topMenu) => {
    // console.log("toggleDropDown", topMenu);
    showDrop((prev) => (prev === topMenu ? null : topMenu));
  };
  return (
    <header className="navbar-header">
      <div className="page-container topbar-menu">
        <div className="d-flex align-items-center gap-2">
          {/* Logo */}
          <a href="/" className="logo">
            <span className="logo-light">
              <span className="logo-lg">
                <img src={LogoImg} alt="User Panel Logo" />
              </span>
              <span className="logo-sm">
                <img src={LogoImg} alt="small logo" />
              </span>
            </span>

            <span className="logo-dark">
              <span className="logo-lg">
                <img src={LogoImg} alt="dark logo" />
              </span>
            </span>
          </a>

          {/* Sidebar Mobile Button */}
          <a id="mobile_btn" className="mobile-btn" onClick={toggleMenuSidebar}>
            <i className="ti ti-menu-deep fs-24"></i>
          </a>

          <button
            id="toggle_btn2"
            className="sidenav-toggle-btn btn border-0 p-0 active"
          >
            <i className="ti ti-arrow-right"></i>
          </button>

          {/* Search */}
          <div className="me-auto d-flex align-items-center header-search d-lg-flex d-none">
            <div className="input-icon-start position-relative me-2">
              <span className="input-icon-addon">
                <i className="ti ti-search"></i>
              </span>

              <input
                type="text"
                className="form-control shadow-sm"
                placeholder="Search"
              />

              <span className="input-icon-addon text-dark shadow fs-18 d-inline-flex p-0 header-search-icon">
                <i className="ti ti-command"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center">
          {/* Mobile Search */}
          <div className="header-item d-flex d-lg-none me-2">
            <button
              className="topbar-link btn btn-icon"
              data-bs-toggle="modal"
              data-bs-target="#searchModal"
              type="button"
            >
              <i className="ti ti-search fs-16"></i>
            </button>
          </div>

          {/* AI Assistance */}
          {/* <a href="#" className="btn btn-liner-gradient me-3 d-lg-flex d-none">
            AI Assistance <i className="ti ti-chart-bubble-filled ms-1"></i>
          </a> */}

          {/* Appointment */}
          <div className="header-item">
            <div className="dropdown me-2">
              <Link to="/scheduled-appointments" className="btn topbar-link">
                <i className="ti ti-calendar-due"></i>
              </Link>
            </div>
          </div>

          {/* Settings */}
          <div className="header-item">
            <div className="dropdown me-2">
              <a href="profile-settings.html" className="btn topbar-link">
                <i className="ti ti-settings-2"></i>
              </a>
            </div>
          </div>

          {/* Light/Dark Mode */}
          <div className="header-item d-none d-sm-flex me-2">
            <button
              className="topbar-link btn btn-icon"
              id="light-dark-mode"
              type="button"
            >
              <i className="ti ti-moon fs-16"></i>
            </button>
          </div>

          {/* Notifications */}
          <div className="header-item">
            <div className="dropdown me-3">
              <button
                onClick={() => toggleDropDown("Notifications")}
                className="topbar-link btn btn-icon dropdown-toggle drop-arrow-none"
                data-bs-toggle="dropdown"
                data-bs-offset="0,24"
                type="button"
              >
                <i className="ti ti-bell-check fs-16 animate-ring"></i>
                <span className="notification-badge"></span>
              </button>

              {/* Notification Body */}
              {drop == "Notifications" && (
                <div
                  className="dropdown-menu p-0 dropdown-menu-end dropdown-menu-lg"
                  style={{ minHeight: "300px" }}
                >
                  <div className="p-2 border-bottom">
                    <div className="row align-items-center">
                      <div className="col">
                        <h6 className="m-0 fs-16 fw-semibold">Notifications</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    className="notification-body position-relative z-2 rounded-0"
                    data-simplebar
                  >
                    {/* Notification Items */}
                    {[
                      {
                        id: 1,
                        img: "assets/img/doctors/doctor-01.jpg",
                        name: "Dr. Smith",
                        text: "updated the surgery schedule.",
                        time: "4 min ago",
                      },
                      {
                        id: 2,
                        img: "assets/img/doctors/doctor-06.jpg",
                        name: "Dr. Patel",
                        text: "completed a follow-up report for Emily.",
                        time: "8 min ago",
                      },
                      {
                        id: 3,
                        img: "assets/img/doctors/doctor-02.jpg",
                        name: "Emily",
                        text: "booked an appointment with Dr. Patel for April 15.",
                        time: "15 min ago",
                      },
                      {
                        id: 4,
                        img: "assets/img/doctors/doctor-07.jpg",
                        name: "Amelia",
                        text: "completed the pre-visit health questionnaire.",
                        time: "20 min ago",
                      },
                    ].map((item) => (
                      <div
                        key={item.id}
                        className="dropdown-item notification-item py-3 text-wrap border-bottom"
                        id={`notification-${item.id}`}
                      >
                        <div className="d-flex">
                          <div className="me-2 position-relative flex-shrink-0">
                            <img
                              src={item.img}
                              className="avatar-md rounded-circle"
                              alt=""
                            />
                          </div>
                          <div className="flex-grow-1">
                            <p className="mb-0 fw-medium text-dark">
                              {item.name}
                            </p>
                            <p className="mb-1 text-wrap">{item.text}</p>

                            <div className="d-flex justify-content-between align-items-center">
                              <span className="fs-12">
                                <i className="ti ti-clock me-1"></i>
                                {item.time}
                              </span>

                              <div className="notification-action d-flex align-items-center gap-2">
                                <a
                                  href="#"
                                  className="notification-read rounded-circle bg-danger"
                                  data-bs-toggle="tooltip"
                                />
                                <button className="btn rounded-circle p-0">
                                  <i className="ti ti-x"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {/* View All */}
                  <div className="p-2 rounded-bottom border-top text-center">
                    <a
                      href="notifications.html"
                      className="text-decoration-underline fs-14"
                    >
                      View All Notifications
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* User Dropdown */}
          <div className="dropdown profile-dropdown d-flex align-items-center justify-content-center">
            <button
              onClick={() => toggleDropDown("UserDropDown")}
              className="topbar-link dropdown-toggle drop-arrow-none position-relative usertopbaricon"
              data-bs-toggle="dropdown"
              data-bs-offset="0,22"
            >
              <img
                src="assets/img/users/user-01.jpg"
                width="32"
                className="rounded-circle"
                alt="user"
              />
              <span className="online text-success">
                <i className="ti ti-circle-filled d-flex bg-white rounded-circle border border-1 border-white"></i>
              </span>
            </button>

            {drop === "UserDropDown" && (
              <div className="dropdown-menu dropdown-menu-end dropdown-menu-md p-2">
                <div className="d-flex align-items-center bg-light rounded-3 p-2 mb-2">
                  <img
                    src="assets/img/users/user-01.jpg"
                    width="42"
                    height="42"
                    className="rounded-circle"
                    alt=""
                  />
                  <div className="ms-2">
                    <p className="fw-medium text-dark mb-0">Jimmy Anderson</p>
                    <span className="fs-13">Administrator</span>
                  </div>
                </div>

                <Link to="/patient-profile-settings" className="dropdown-item">
                  <i className="ti ti-user-circle me-1"></i> Profile Settings
                </Link>

                <a href="account-settings.html" className="dropdown-item">
                  <i className="ti ti-settings me-1"></i> Account Settings
                </a>

                <div className="form-check form-switch form-check-reverse d-flex align-items-center justify-content-between dropdown-item mb-0">
                  <label className="form-check-label" htmlFor="notify">
                    <i className="ti ti-bell me-1"></i> Notifications
                  </label>
                  <input
                    className="form-check-input me-0"
                    type="checkbox"
                    id="notify"
                  />
                </div>

                <a href="transactions.html" className="dropdown-item">
                  <i className="ti ti-transition-right me-1"></i> Transactions
                </a>

                <div className="pt-2 mt-2 border-top">
                  <a href="login.html" className="dropdown-item text-danger">
                    <i className="ti ti-logout me-1 fs-17"></i> Log Out
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
